import * as React from 'react';
// Global styles first, then tacho-ui (Tacho.Web/src/libs/ui): its components bring their own CSS, which must load
// right after the global styles and before any app module — the place of the old tacho-ui/dist/index.css.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';
import 'tacho-ui';
import { Provider as ReduxProvider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import { IntlProvider } from 'react-intl';
import { currentTranslations } from './core/locales/locale';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './state/store';
import { Navigate, Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import { LoadingOverlay } from './app/components/LoadingOverlay';
import { authProvider } from './core/helpers/msal';
import { MsalProvider } from '@azure/msal-react';
import { App } from './app/templates';
import { createRoot } from 'react-dom/client';
import { MainContainer } from './app/pages';
import { NotFoundPage } from './app/pages/notFoundPage';

const initApp = async () => {
    await authProvider.initialize();
    const RootRoutes = (
        <Route path="/" element={<App />}>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/home" element={<MainContainer />} />
            <Route path="*" element={<NotFoundPage />} />
        </Route>
    );
    const routes = createRoutesFromElements(RootRoutes);
    const router = createBrowserRouter(routes);
    const ConnectedApp = () => (
        <MsalProvider instance={authProvider}>
            <ReduxProvider store={store}>
                <IntlProvider locale={navigator.language} messages={currentTranslations?.values}>
                    <PersistGate loading={<LoadingOverlay pending={true} />} persistor={persistor}>
                        <React.StrictMode>
                            <RouterProvider router={router}></RouterProvider>
                        </React.StrictMode>
                    </PersistGate>
                </IntlProvider>
            </ReduxProvider>
        </MsalProvider>
    );
    const root = createRoot(document.getElementById('root') as HTMLElement);
    root.render(
        <React.StrictMode>
            <ConnectedApp />
        </React.StrictMode>,
    );
};

initApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//if (process.env.NODE_ENV === 'production') {
//    serviceWorker.register();
//} else {
serviceWorker.unregister();
//}

reportWebVitals(console.log);
